
import { utils } from 'zero';

const { Base } = utils;

export function openTab(title, id, url) {
  const rand = Base.genRandomId();

  if (url.indexOf('?') > -1) {
    url += `&randId=${rand}`;
  } else {
    url += `?randId=${rand}`;
  }

  if (window === window.top) {
    // url.split('/').shift();
    // console.log(url)
    window.open(url);
  } else {
    window.top.tabCont(title, id + rand, url);
  }
}

export function closeTab(id) {
  if (window === window.top) {
    window.close();
  } else {
    window.top.document.querySelector(`#close_${id}${utils.getUrlParam().randId}`).click();
  }
}



// WEBPACK FOOTER //
// ./example/src/utils/common.js